import createReactComponent from '../createReactComponent';
export default createReactComponent('package-import', 'IconPackageImport', [
  ['path', { d: 'M12 21l-8 -4.5v-9l8 -4.5l8 4.5v4.5', key: 'svg-0' }],
  ['path', { d: 'M12 12l8 -4.5', key: 'svg-1' }],
  ['path', { d: 'M12 12v9', key: 'svg-2' }],
  ['path', { d: 'M12 12l-8 -4.5', key: 'svg-3' }],
  ['path', { d: 'M22 18h-7', key: 'svg-4' }],
  ['path', { d: 'M18 15l-3 3l3 3', key: 'svg-5' }],
]);
